module.exports = __webpack_public_path__ + "img/bet_amount_icon.f0e2ce0a.svg";